import React from 'react';
import { FormattedMessage } from 'react-intl/dist';

import { GIButton, Modal } from 'app-components';

import { ModalContextType } from '../../../contexts/modalContext';
import { ConditionalRendering } from '../../../components/common/conditional-rendering';
import { useStateCode } from '../../../hooks';
import { PLAN_TYPE } from './modalTypes';
import CapitalizedButton from '../components/common/CapitalizedButton';

interface IModalProps extends ModalContextType {
    hasEnrollmentAction: boolean;
    typeOfPlan: PLAN_TYPE;
    electedAptc: number;
    goToDisenrollDateModal: Function;
}
export default function AreYouSure({ hasEnrollmentAction, typeOfPlan, electedAptc, goToDisenrollDateModal, closeModal }: IModalProps) {

    const { isDisEnroll2Warning } = useStateCode();

    function onClose(e) {
        e?.preventDefault();
        closeModal('areYouSure');
    }
    function onContinue() {
        goToDisenrollDateModal();
        closeModal('areYouSure');
    }

    function getModalHeader(): string {
        const keyPrefix = hasEnrollmentAction
            ? 'indportal.plansummary.doyouwanttocontinue'
            : 'indportal.plansummary.cancel.doyouwanttocontinue';

        switch (typeOfPlan) {
            case PLAN_TYPE.DENTAL:
                return `${keyPrefix}.dental`;
            case PLAN_TYPE.HEALTH:
                return hasEnrollmentAction
                    ? keyPrefix
                    : `${keyPrefix}.health`;
            case PLAN_TYPE.BOTH:
                return 'indportal.plansummary.doyouwanttocontinueboth';
            default:
                return '';
        }
    }

    return (
        <Modal id="PayNowModal">
            <Modal.Header id="PayNowModalHeader" titleId={getModalHeader()} onHide={onClose} />
            <Modal.Body id="PayNowModalBody">
                <ConditionalRendering isTrue={typeOfPlan === PLAN_TYPE.HEALTH}>
                    <p>
                        <FormattedMessage id="indportal.plansummary.youhaveseelctedtodisenroll" />
                    </p>
                </ConditionalRendering>
                <ConditionalRendering isTrue={typeOfPlan === PLAN_TYPE.DENTAL && isDisEnroll2Warning}>
                    <p>
                        <FormattedMessage id="indportal.plansummary.youhaveseelctedtodisenroll" />
                    </p>
                    <p>
                        <FormattedMessage id="indportal.plansummary.ifyoucanaffordbut" />
                    </p>
                </ConditionalRendering>
                <ConditionalRendering isTrue={typeOfPlan === PLAN_TYPE.DENTAL && !isDisEnroll2Warning}>
                    <p>
                        <FormattedMessage id="indportal.plansummary.youhaveseelctedtodisenrolldental" />
                    </p>
                    <p>
                        <FormattedMessage id="indportal.plansummary.youhaveseelctedtodisenroll2dental" />
                    </p>
                </ConditionalRendering>
                <ConditionalRendering isTrue={typeOfPlan === PLAN_TYPE.BOTH && !isDisEnroll2Warning}>
                    <p>
                        <FormattedMessage id="indportal.plansummary.youhaveseelctedtodisenrollboth" />
                    </p>
                    <p>
                        <FormattedMessage id="indportal.plansummary.youhaveseelctedtodisenroll2both" />
                    </p>
                    <a
                        href="https://www.coveredca.com/individuals-and-families/getting-covered/special-enrollment/qualifying-life-events/"
                        target="_blank"
                    >
                        <FormattedMessage id="indportal.plansummary.youhaveseelctedtodisenroll2_1" />
                    </a>
                    <p>
                        <FormattedMessage id="indportal.plansummary.youhaveseelctedtodisenroll3both" />
                    </p>
                </ConditionalRendering>
                <ConditionalRendering isTrue={typeOfPlan === PLAN_TYPE.DENTAL && electedAptc > 0}>
                    <p>
                        <FormattedMessage id="indportal.plansummary.aptcwarning" />
                    </p>
                </ConditionalRendering>
                <ConditionalRendering isTrue={typeOfPlan === PLAN_TYPE.HEALTH || typeOfPlan === PLAN_TYPE.BOTH}>
                    <p>
                        <FormattedMessage id="indportal.plansummary.ifyoucanaffordbut" />
                    </p>
                </ConditionalRendering>
            </Modal.Body>
            <Modal.Controls>
                <CapitalizedButton
                    id="areYouSureModalCancelButton"
                    onClickHandler={onClose}
                    variant="secondary"
                    labelId="button.cancel"
                />
                <CapitalizedButton
                    id="areYouSureModalContinueButton"
                    labelId="button.continue"
                    variant="primary"
                    onClickHandler={onContinue}
                    leftMargin={true}
                />
            </Modal.Controls>
        </Modal>
    );
}
